<template>
	<div class="dayInfo">
		<div class="daily-budget-wrapper">
			<div class="budget-title">
				<span>Daily Budget</span>
				<span class="budjet-limit-btn" v-if="overBudgetPercentage">{{ overBudgetPercentage }} OB</span>
			</div>
			<div class="budget-details">
				<p>
					<span>{{ currentAmount }}</span> / {{ limitAmount }}
				</p>
			</div>
		</div>
		<div class="assined-shifts-wrapper">
			<h5 class="title">Assigned</h5>
			<div class="assigned-shifts">
				<day-info-shift-row
					v-for="(element, index) in dayInfoShifts"
					:key="index"
					:position="element.position"
					:current="element.current"
					:total="element.total"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import dayInfoShiftRow from './dayInfoShiftRow';
export default {
	name: 'dayInfo',
	components: { dayInfoShiftRow },
	props: {
		overBudgetPercentage: { required: false },
		currentAmount: { required: false },
		limitAmount: { required: false },
		dayInfoShifts: { required: false, type: Array },
	},
	computed: {},
};
</script>

<style lang="scss" scoped>
.dayInfo {
	position: absolute;
	top: 40px;
	left: -48px;
	right: 0;
	width: 271px;
	z-index: 100;
	margin-left: auto;
	margin-right: auto;
	padding: 20px 30px;
	box-shadow: 0 0 10px 0 #e3e3e3;
	background-color: #ffffff;

	&::before {
		content: '';
		border-style: solid;
		border-width: 4px 15px 10px 0;
		border-color: transparent #fff transparent transparent;
		position: absolute;
		transform: rotate(-34deg);
		top: -7px;
		left: 0;
		right: 0;
		width: 20px;
		margin-left: auto;
		margin-right: auto;
	}

	.daily-budget-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;

		.budget-title {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 10px;
			width: 100%;

			span {
				font-size: 12px;
				color: #616e84;
			}
			.budjet-limit-btn {
				padding: 4px 10px;
				border-radius: 3.4px;
				background-color: #d10922;
				color: #fff;
				font-size: 11px;
			}
		}
		.budget-details {
			font-size: 20px;
			color: #616e84;
			p {
				font-size: 20px;
				span {
					font-weight: bold;
				}
			}
		}
	}
	.assined-shifts-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		.title {
			width: 100%;
			align-items: flex-start;
			display: flex;
		}

		.assigned-shifts {
			width: 100%;
		}
	}
}
</style>
